import CryptoJS from 'crypto-js';

const SECRET_KEY = 'b47fbb6b17cf2a4082995a01e60dcb763ba18ac26e96f0d9eafaa35f7b6459c8';

export const encryptData = (data: any): string => {
  const jsonData = JSON.stringify(data);
  return CryptoJS.AES.encrypt(jsonData, SECRET_KEY).toString();
};

export const decryptData = (cipherText: string): any => {
  try {
    const bytes = CryptoJS.AES.decrypt(cipherText, SECRET_KEY);
    const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedText);
  } catch (error) {
    console.error("Decryption failed:", error);
    return null;
  }
};
